import entity from '../../../models/base/workflows'

export default [
  {
    path: '/workflows',
    meta: {
      entity,
      requiresPermissionTo: 'workflows',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/workflows/new',
    meta: {
      entity,
      requiresPermissionTo: 'workflows',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/workflows/:id',
    meta: {
      entity,
      requiresPermissionTo: 'workflows',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
